import React from "react";
import { createRoot } from "react-dom/client";
import AirframeMroEventData from "./AirframeMroEventData";
import { testimonialsType } from "../../common/types/product";

declare global {
	interface Window {
		renderAirframeMroEventsData: unknown;
	}
}

export function renderAirframeMroEventsData(
	rootId: string,
	title: string,
	subscribeLink: string,
	testimonials: testimonialsType,
) {
	const root = createRoot(document.getElementById(rootId)!);
	root.render(
		<AirframeMroEventData
			packageName={title}
			subscribeLink={subscribeLink}
			testimonials={testimonials}
		/>,
	);
}

window.renderAirframeMroEventsData = renderAirframeMroEventsData;
